var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg002Penguin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m419.693 452.835c56.404-46.959 92.307-117.704 92.307-196.835 0-141.385-114.615-256-256-256s-256 114.615-256 256c0 79.131 35.903 149.876 92.307 196.835z",
    fill: "#a3d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.693 452.835c53.523-44.56 88.585-110.538 92.028-184.775l-167.621-168.004z",
    fill: "#65b1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171 163.27c0-19.314 15.657-34.971 34.971-34.971 19.314 0 34.971 15.657 34.971 34.971v15.354h30.114v-15.354c0-19.314 15.657-34.971 34.971-34.971 19.314 0 34.971 15.657 34.971 34.971v334.28c29.011-10.208 55.629-25.495 78.787-44.794l-48.436-294.81c-9.278-56.489-58.103-97.946-115.349-97.946-57.246 0-106.071 41.457-115.351 97.946l-48.435 294.81c23.158 19.298 49.776 34.585 78.787 44.794v-334.28z",
    fill: "#636978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.787 452.756-48.435-294.81c-9.281-56.489-58.105-97.946-115.352-97.946-.005 0-.009 0-.014 0v118.624h15.071v-15.354c0-19.314 15.657-34.971 34.971-34.971s34.971 15.657 34.971 34.971v334.28c29.012-10.209 55.63-25.495 78.788-44.794z",
    fill: "#414952"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.335 124.405c-19.432 0-35.185 15.753-35.185 35.185v15.448h-30.299v-15.448c0-19.432-15.753-35.185-35.185-35.185-19.432 0-35.185 15.753-35.185 35.185v337.776c26.742 9.476 55.528 14.634 85.519 14.634s58.777-5.158 85.52-14.633v-337.776c0-19.433-15.753-35.186-35.185-35.186z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.335 124.405c-19.432 0-35.185 15.753-35.185 35.185v15.448h-15.163v336.962h.014c29.991 0 58.777-5.157 85.52-14.633v-337.776c-.001-19.433-15.754-35.186-35.186-35.186z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.792,
    cy: 172.432,
    fill: "#414952",
    rx: 17.347,
    ry: 17.347,
    transform: "matrix(.228 -.974 .974 .228 -9.801 332.503)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.208,
    cy: 172.432,
    fill: "#23272b",
    rx: 17.347,
    ry: 17.347,
    transform: "matrix(.707 -.707 .707 .707 -31.949 267.733)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271.235 212.83-15.249 24.319-15.221-24.319v-40.398h30.47z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.986 172.432v64.717l15.249-24.319v-40.398z",
    fill: "#fdba12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg002Penguin);
export default __webpack_public_path__ + "static/media/002-penguin.3cbc9f337b960887460906f334e60d57.svg";
export { ForwardRef as ReactComponent };